import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { TileListComponent } from '@/components';
import AccordionModal from "../AccordionModal";

const Page = ({
                 parentId,
                 headline,
                 onItemClick,
                 loadingIndex,
                 isFetching,
                 values,
                 tooltip
               }) => {
  const [componentState, updateComponentState] = useImmer({
    isModalOpen: false,
    activeAccordionIndex: values.findIndex((value) => value.is_selected),
  });

  const selectTooltip = (i) => {
    updateComponentState((draft) => {
      draft.activeAccordionIndex = i;
    });
  };

  const openModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = true;
    });
  };

  const closeModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = false;
    });
  };

  useEffect(() => {
    document.body.style.overflow = componentState.isModalOpen ? 'hidden' : '';
  }, [componentState.isModalOpen]);

  useEffect(() => {
    if (!loadingIndex && componentState.isModalOpen) {
      closeModal();
    }
  }, [loadingIndex]);

  return (
    <>
      <TileListComponent
        id='pages'
        parentId={parentId}
        getItemDataAttributes={(item) => ({'data-pages': item.id})}
        tileClassName="w-full h-6xl laptop:w-1/2 laptop:h-[4.375rem]"
        isDisabled={isFetching}
        items={values}
        LoadingIcon={() => (
          <ft-spinner size="small"></ft-spinner>
        )}
        linkText={values.every(value => value.tooltip && value.tooltip.trim() !== '') ? Drupal.t('Compare Print') : false}
        onLinkClick={() => openModal()}
        {...{
          headline,
          onItemClick,
          loadingIndex
        }}
      />
      <If condition={componentState.isModalOpen}>
        <AccordionModal
          headline={Drupal.t('Compare Print')}
          ctaLabel={Drupal.t('Select Print')}
          closeModal={() => closeModal()}
          values={values}
          activeAccordionIndex={componentState.activeAccordionIndex}
          selectTooltip={selectTooltip}
          parentId={parentId}
          onItemClick={onItemClick}
          loadingIndex={loadingIndex}
        />
      </If>
    </>
  );
};

export default Page;
